import React, { useState, useEffect, useRef } from "react";
import { BsFilter } from "react-icons/bs";

const AdminLectureFilterComp = ({
  filterQuery,
  handleInputChange,
  courseData,
  batchData,
  lectureFor,
  setLectureFor,
  fetchLecturesData,
  handleResetFilter,
}) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [contentHeight, setContentHeight] = useState(); // Track height state
  const contentRef = useRef(null); // Reference for content

  const toggleFilter = () => {
    if (openFilter) {
      const height = contentRef.current.scrollHeight;
      setContentHeight(height);
    } else {
      setContentHeight(0);
    }
  };

  // Trigger the height change whenever openFilter changes
  React.useEffect(() => {
    toggleFilter();
  }, [openFilter]);

  return (
    <div
      className="shadow-md z-10 rounded-md p-2 mb-4 bg-white lg:sticky top-0 w-full "
      bkl="AdminLectureFilterComp"
    >
      <div
        className={`overflow-y-auto transition-all duration-500 ease-in-out`}
        style={{ height: `${contentHeight}px` }}
      >
        <form ref={contentRef} className="xs:overflow-y-auto xs:h-64">
          <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 xs:gap-2 w-full ">
            <label className="form-control w-full">
              <span className="label  text-slate-500">Title :</span>
              <input
                name="title"
                type="search"
                value={filterQuery.title}
                onChange={handleInputChange}
                placeholder="Search by lecture title..."
                className="px-4 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
            <label className="form-control w-full">
              <span className="label  text-slate-500">Title Details :</span>
              <input
                name="remarks"
                type="search"
                value={filterQuery.remarks}
                onChange={handleInputChange}
                placeholder="Search by the lecture details ..."
                className="px-4 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>

          <div className="mt-2 p-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 w-full ">
            <label className="form-control w-full">
              <span className="label text-slate-500">Course :</span>
              <select
                name="course"
                value={filterQuery.course}
                onChange={handleInputChange}
                className="select select-sm px-4 py-1 h-auto   outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
              >
                <optgroup label="Select Course">
                  {courseData.map((course) => (
                    <option key={course} value={course}>
                      {course}
                    </option>
                  ))}
                </optgroup>
              </select>
            </label>

            <label className="form-control w-full">
              <span className="label text-slate-500">Select Batch</span>
              <select
                name="batch"
                value={filterQuery.batch}
                className="select select-sm px-4 py-1 h-auto  outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
                onChange={handleInputChange}
              >
                <option
                  value={""}
                  key={"Select-batch"}
                  disabled
                  style={{ fontWeight: "bold", color: "black" }}
                >
                  Select Batch
                </option>
                {batchData.map((batch, i) => (
                  <option value={batch} key={batch + i}>
                    {batch}
                  </option>
                ))}
              </select>
            </label>

            <label className="form-control w-full">
              <span className="label text-slate-500">Category :</span>
              <select
                name="category"
                value={filterQuery.category}
                onChange={handleInputChange}
                className="select select-sm px-4 py-1 h-auto  outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
              >
                <optgroup label="Select Category">
                  <option value="Coding">Coding</option>
                  <option value="DSA">DSA</option>
                  <option value="Assignment">Assignment</option>
                  <option value="Scrum">Scrum</option>
                  <option value="Other">Other</option>
                </optgroup>
              </select>
            </label>

            <label className="form-control w-full">
              <span className="label text-slate-500">Lecture Mode :</span>
              <select
                name="lectureMode"
                value={filterQuery.lectureMode}
                onChange={handleInputChange}
                className="select select-sm px-4 py-1 h-auto  outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
              >
                <optgroup label="Select Lecture Mode">
                  <option value="Live">Live</option>
                  <option value="Video">Video</option>
                  <option value="Reading">Reading</option>
                </optgroup>
              </select>
            </label>

            <label className="form-control w-full">
              <span className="label text-slate-500">From</span>
              <input
                type="date"
                name="from"
                value={filterQuery.from}
                onChange={handleInputChange}
                className="px-4 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                placeholder="Daisy"
              />
            </label>

            <label className="form-control w-full">
              <span className="label text-slate-500">Upto</span>
              <input
                type="date"
                name="upto"
                value={filterQuery.upto}
                onChange={handleInputChange}
                className="px-4 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                placeholder="Daisy"
              />
            </label>
          </div>
        </form>
      </div>

      <div className="mt-4  flex flex-row justify-between gap-2 xs:flex-wrap-reverse">
        <div className="flex sm:mb-0 mb-4">
          <button
            className={`btn btn-sm  tracking-[.1em] rounded-l-md rounded-r-none ${
              lectureFor === "today"
                ? "bg-pink-800 hover:bg-pink-700 text-white"
                : ""
            }`}
            onClick={() => setLectureFor("today")}
          >
            Today
          </button>
          <button
            className={`btn btn-sm  tracking-[.1em] rounded-none ${
              lectureFor === "upcoming"
                ? "bg-pink-800 hover:bg-pink-700 text-white"
                : ""
            }`}
            onClick={() => setLectureFor("upcoming")}
          >
            Upcoming
          </button>
          <button
            className={`btn btn-sm  tracking-[.1em] rounded-l-none rounded-r-md ${
              lectureFor === "all"
                ? "bg-pink-800 hover:bg-pink-700 text-white"
                : ""
            }`}
            onClick={() => setLectureFor("all")}
          >
            All
          </button>
        </div>

        <div className="flex gap-2 sm:gap-4 ">
          {openFilter ? (
            <>
              <button
                className=" py-1 px-4 rounded-md tracking-[.1em] uppercase text-orange-600 bg-orange-50 hover:bg-orange-100 hover:text-orange-600 border-solid border border-orange-600"
                onClick={(e) => {
                  setOpenFilter(false);
                }}
              >
                Hide
              </button>

              <button
                className=" py-1 px-4 rounded-md tracking-[.1em] uppercase text-red-600 bg-red-50 hover:bg-red-100 hover:text-red-600 border-solid border border-red-600"
                onClick={handleResetFilter}
              >
                Reset
              </button>

              <button
                className=" py-1 px-4 rounded-md tracking-[.1em] uppercase text-white
                  bg-pink-700 hover:bg-pink-800 "
                onClick={fetchLecturesData}
              >
                Apply
              </button>
            </>
          ) : (
            <button
              className={`tracking-[0.5px] flex items-center  justify-center sm:self-end xs:self-end gap-2 py-2 w-[140px] hover:tracking-[1px] transition-all duration-150 border border-pink-600  rounded-lg text-sm md:text-base ${
                openFilter ? "text-[#97266D] bg-[#FAF5FF] font-semibold" : ""
              } hover:bg-[#FAF5FF]`}
              onClick={() => setOpenFilter(true)}
            >
              <BsFilter /> FILTERS
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLectureFilterComp;
